export default __webpack_public_path__ + "static/media/const4.6b18167e.jpg";